import type { IconSvgObject } from './types';

const BitcoinSquareIcon: IconSvgObject = [
  ["path", { d: "M19.5 2.5C20.6046 2.5 21.5 3.39543 21.5 4.5V19.5C21.5 20.6046 20.6046 21.5 19.5 21.5H4.5C3.39543 21.5 2.5 20.6046 2.5 19.5V4.5C2.5 3.39543 3.39543 2.5 4.5 2.5H19.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 8.5H10M13.25 12H10M13.25 12C14.2165 12 15 11.2165 15 10.25C15 9.2835 14.2165 8.5 13.25 8.5H12M13.25 12C14.2165 12 15 12.7835 15 13.75C15 14.7165 14.2165 15.5 13.25 15.5H12M10 12V8.5M10 12V15.5M9 15.5H10M10 8.5H12M10 15.5H12M12 8.5V7.5M12 15.5V16.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BitcoinSquareIcon;
